import { render, staticRenderFns } from "./CameraSetting.vue?vue&type=template&id=1b477ce9&scoped=true&"
import script from "./CameraSetting.vue?vue&type=script&lang=ts&"
export * from "./CameraSetting.vue?vue&type=script&lang=ts&"
import style0 from "./CameraSetting.vue?vue&type=style&index=0&id=1b477ce9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b477ce9",
  null
  
)

export default component.exports